<template>
  <div class="favoSelectPage">
    <step :active="3"></step>
    
    <div class="favoContainer">
      <div class="favoHeader">
        <h3 class="favoTit">欢迎您使用商贸邀约对接服务</h3>
        <div class="favoDesc">
          致力于链动全球贸易，提供专业的线上线下智能营销解决方案以及精准供需对接服务，全面提升成交效率。
        </div>
        <div class="selected-display">
          <div class="selected-info">
            <span class="selected-icon">🎯</span>
            <span class="selected-text">
              已选择拜访
              <span class="selected-count">{{ selectedCount }}</span>
              家优质参展商，加入商机日历日程，并交换名片
            </span>
          </div>
        </div>
      </div>

      <div class="favoListBox">
        <van-checkbox-group v-model="favoChecked">
          <div class="list-title">本届甄选展商・必打卡推荐</div>
          <ul>
            <li
              class="favoItem"
              v-for="item in favoData"
              :key="item.actorID"
            >
              <div class="favoItemMsg" @click="nvactor(item.uuid)">
                <div class="imgBox">
                  <img :src="item.logoUrl" v-if="item.logoUrl" />
                  <img v-else :src="company" />
                </div>
                <div class="atrName">
                  <p class="actor-name">{{ item.actorname }}</p>
                  <p class="bthNum">
                    展位号：<span>{{ item.boothNum }}</span>
                  </p>
                  <p>
                    <span
                      v-if="item.actorProducts && item.actorProducts.length > 0"
                      class="product-names"
                      :title="item.actorProducts.map(product => product.productName).join('、')"
                    >
                      主营产品： {{ item.actorProducts.map(product => product.productName).join('、') }}
                    </span>
                  </p>
                  <div class="product-images-container">
                    <div class="product-images">
                      <img
                        v-for="(it, index) in item.actorProducts"
                        :key="index"
                        :src="it.produtUrl"
                        :alt="it.name || '产品图片'"
                        class="product-image"
                      />
                    </div>
                  </div>
                </div>
                <van-checkbox
                  :name="item.actorID"
                  :checked-color="mainColor"
                  shape="square"
                  class="item-checkbox"
                  @click.stop
                ></van-checkbox>
              </div>
            </li>
          </ul>
        </van-checkbox-group>
      </div>

      <div class="favo-btm-box">
        <van-button
          :color="btnColor"
          type="primary"
          round
          block
          @click="favoConfirm"
        >
          加入日程并交换名片
        </van-button>
        <div class="skip-btn" @click="favoCancel">下次再选</div>
      </div>
    </div>

    <!-- 确认弹窗 -->
    <van-popup v-model:show="showConfirmModal" round closeable :style="{ width: '80%' }">
      <div class="confirm-modal-content">
        <div class="confirm-title">提示</div>
        <div class="confirm-message">放弃与优质展商会面日程？</div>
        <div class="confirm-buttons">
          <van-button
            class="confirm-btn-cancel"
            @click="confirmSkip"
          >
            是
          </van-button>
          <van-button
            class="confirm-btn-confirm"
            :color="btnColor"
            @click="closeConfirmModal"
          >
            否
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import api from '@/api'
import { useStore } from 'vuex'
import step from '@/components/step.vue'
import { showFailToast } from 'vant'
import { useRouter } from 'vue-router'
import { decryptionECB } from '@/utils/utils.js'
import company from '@/assets/company.png'

const btnColor = ref(
  'linear-gradient( 90deg, #091be1 0%, #0169d8 70%,  #01a9ed 100%)'
)

const store = useStore()
const router = useRouter()
const ExhCode = computed(() => store.state.ExhCode)
const VisitorID = computed(() => store.state.VisitorID)
const mainColor = computed(() => store.state.mainColor)
const gconfig = computed(() => getConfigObj(store.state.gconfig))

const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalValue
    })
  }
  return configObj
}

// 商家选择
const favoChecked = ref([])
const favoData = ref([])
const selectedCount = ref(0)
const showConfirmModal = ref(false)

// 监听选择变化
watch(favoChecked, (newVal) => {
  selectedCount.value = newVal.length
})

// 获取商家列表
const getFavoList = async () => {
  const res = await api.getactorlistApi({
    exhcode: ExhCode.value,    
    VisitorID: VisitorID.value
  })
  if (res.code === 200) {
    favoData.value = res.data
  }
}

// 确认选择
const favoConfirm = async () => {
  if (selectedCount.value === 0) {
    showFailToast('请选择优质参展商')
    return
  }
  
  const params = {
    FavoriteSeller: favoChecked.value.join(','),
    visitorid: VisitorID.value
  }
  const res = await api.savefavoriteApi(params)
  if (res.code === 200) {
    goToSuccess()
  }
}

// 取消选择
const favoCancel = () => {
  showConfirmModal.value = true
}

// 关闭确认弹窗
const closeConfirmModal = () => {
  showConfirmModal.value = false
}

// 确认跳过
const confirmSkip = () => {
  showConfirmModal.value = false
  goToSuccess()
}

// 跳转到成功页
const goToSuccess = () => {
  if (gconfig.value.SuccessPageVersion === 'V2') {
    router.push({ path: '/successV2' })
  } else {
    router.push({ path: '/success' })
  }
}

// 跳转展商详情
const nvactor = (uuid) => {
  // eslint-disable-next-line no-undef
  wx.miniProgram.navigateTo({
    url: '/pages/company/company/detail/companyDetail?companyGuid=' + uuid
  })
}

onMounted(() => {
  if (!VisitorID.value) {
    router.push({ path: '/login' })
    return
  }
  getFavoList()
})
</script>

<style lang="less" scoped>
.favoSelectPage {
  background: #f6f6f6;
  min-height: 100vh;
  padding-bottom: 25vw;
}

.favoContainer {
  background: #fff;
  width: 92%;
  margin: 20px auto;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0px 0px 5px #cecece;
}

.favoHeader {
  padding: 10px;
  margin-bottom: 10px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);

  .favoTit {
    font-size: 1em;
    padding: 3vw 0;
    text-align: left;
    color: #481425;
    font-weight: 700;
  }

  .favoDesc {
    font-size: 12px;
    text-align: left;
    color: #666;
  }

  .selected-display {
    font-size: 14px;
    margin-top: 10px;

    .selected-info {
      display: flex;
      align-items: center;
    }

    .selected-icon {
      margin-right: 5px;
    }

    .selected-text {
      font-weight: 700;
    }

    .selected-count {
      color: red;
    }
  }
}

.favoListBox {
  padding-bottom: 10px;

  .list-title {
    text-align: left;
    padding-left: 1em;
    font-weight: 700;
    margin-bottom: 10px;
  }

  ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .favoItem {
    border: 1px solid #ececec;
    padding: 2vw;
    margin-bottom: 2vw;
    border-radius: 8px;

    .favoItemMsg {
      display: flex;
      width: 100%;
      position: relative;

      .imgBox {
        width: 15vw;
        height: 15vw;
        padding: 1vw;
        border: 1px solid #ececec;
        margin-right: 2vw;
        flex-shrink: 0;
        
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }

      .atrName {
        flex: 1;
        min-width: 0;
        text-align: left;
        padding-right: 30px;

        .actor-name {
          font-size: 0.9em;
          font-weight: 600;
          word-wrap: break-word;
        }

        .bthNum {
          font-size: 0.7rem;
          color: #817e7e;
          padding-top: 1vw;
          
          span {
            font-weight: bold;
            color: #55A972;
          }
        }

        .product-names {
          font-size: 0.7rem;
          color: #666;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .item-checkbox {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
}

.product-images-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin-top: 8px;

  &::-webkit-scrollbar {
    display: none;
  }
}

.product-images {
  display: flex;
  gap: 8px;
  padding: 4px 0;
  width: max-content;
  max-width: 100%;
}

.product-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;
}

.favo-btm-box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 3vw 5vw;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.1);

  .skip-btn {
    color: #666;
    font-size: 12px;
    margin-top: 8px;
    text-align: center;
    cursor: pointer;
  }
}

.confirm-modal-content {
  padding: 20px;
  text-align: center;

  .confirm-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .confirm-message {
    font-size: 16px;
    margin-bottom: 20px;
    color: #333;
  }

  .confirm-buttons {
    display: flex;
    justify-content: space-around;
    gap: 20px;
  }

  .confirm-btn-cancel,
  .confirm-btn-confirm {
    width: 40%;
  }
}
</style>
